module.exports = __webpack_public_path__ + "img/logo_ru.a7f18ebd.png";